export enum channels {
  phone_channel_settings = 'channels.phone_channel_settings',
  allow_call_recording = 'channels.allow_call_recording',
  toggle_channel_call_recording = 'channels.toggle_channel_call_recording',
}